import React from "react";
import Helmet from "react-helmet";
import { SITE_NAME, SITE_URL, DEFAULT_OG_IMAGE } from "../../seo/siteMeta";

// Sets the page title, meta description, canonical URL, robots, Open Graph and Twitter tags from one place.
const Seo = ({ title, description, path, robots = "index, follow", image, type = "website", jsonLd }) => {
    const canonical = path ? `${SITE_URL}${path === "/" ? "/" : path.replace(/\/+$/, "")}` : undefined;
    const ogImage = image || DEFAULT_OG_IMAGE;

    return (
        <Helmet>
            {title && <title>{title}</title>}
            {description && <meta name="description" content={description} />}
            <meta name="robots" content={robots} />
            {canonical && <link rel="canonical" href={canonical} />}

            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:type" content={type} />
            {title && <meta property="og:title" content={title} />}
            {description && <meta property="og:description" content={description} />}
            {canonical && <meta property="og:url" content={canonical} />}
            <meta property="og:image" content={ogImage} />

            <meta name="twitter:card" content="summary_large_image" />
            {title && <meta name="twitter:title" content={title} />}
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={ogImage} />

            {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
        </Helmet>
    );
};

export default Seo;
